export const QR_URL_PARAMETER = 'qr';

export const DRAWER_DESKTOP_VIEW = {
  title: 'Scan to pay',
  subtitle: 'Scan with your mobile device and pay from your banking app.',
};
